import { gql } from '__generated__';

export default gql(`
  query GetHomePage($country: String) {
    session {
      id
      user {
        id
        first_name
        full_name
        email
        locale
        registration_summaries(upcoming: true) {
          id
          view_token
          registrations_count
          participant {
            id
          }
          event {
            id
            title
            start_date
            end_date
            project {
              id
              organisation_name
              timezone
            }
            logo {
              id
              url
            }
          }
        }
      }
    }
    recommendedEvents(country: $country) {
      id
      sport_type
      country
      events {
        ...CalenderEventFields
      }
    }
  }
`);
